import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input } from '@angular/core';
import {SureFlowRatingUnitResponse} from '../../../model/sure-flow-rating-unit-response';
import {UnitConversionUtils} from '../../../configurator/unit-conversion-utils';
import { SureFlowPerformanceCoilOutputComponent } from '../../sure-flow-performance-coil-output/sure-flow-performance-coil-output.component';
import { MatIcon } from '@angular/material/icon';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-performance-results-section',
    templateUrl: './performance-results-section.component.html',
    styleUrls: ['./performance-results-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, SureFlowPerformanceCoilOutputComponent, DecimalPipe]
})
export class PerformanceResultsSectionComponent implements OnChanges {

  readonly response = input.required<SureFlowRatingUnitResponse>();
  readonly isMetric = input.required<boolean>();
  collapsed: boolean = false;
  canExpand: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
  }

  getEspUnits(): string {
    return UnitConversionUtils.getEspUnits(this.isMetric());
  }

  getAirflowUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.isMetric());
  }

  getLengthUnits(): string {
    return UnitConversionUtils.getLengthUnits(this.isMetric());
  }

  getExpansionIcon(): string {
    return this.collapsed ? 'arrow_drop_down' : 'arrow_drop_up';
  }

  toggleExpansion(): void {
    if (this.canExpand) {
      this.collapsed = !this.collapsed;
    }
  }

}
